<template>
   <div
      class="hotel-card-wrapper"
      :data-hotel-card-id="hotelCardRandomId"
      :data-board-type="hotelItem.boardTypes"
      :class="isRecommended ? 'recommended-hotel' : ''"
      :data-facilities="hotelItem.allFacilities">
      <div class="hotel-card-inner">
         <!-- HOTEL CARD BADGE -->
         <div class="hotel-card-inner-section hotel-card-tag-wrapper" v-if="isRecommended">
            <span class="hotel-card-tag recommended-tag">{{ $t("hotelCard_lblRecommended") }}</span>
         </div>

         <div class="hotel-card-inner-section hotel-card-tag-wrapper addon-tag" v-if="hotel.addOn">
            <span class="hotel-card-tag">{{ $t("hotelCard_lblhasAddon") }}</span>
         </div>
         <!-- THUMBNAIL SECTION -->
         <div class="hotel-card-inner-section hotel-card-thumbnail" :class="hotel.closedHotel?.isClosed ? 'hotel-closed' : ''" ref="clickedComponent">
            <img
               :src="hotel.thumbnailImage != '' ? hotel.thumbnailImage : defaultImageThumbnail"
               :srcset="`${hotel.thumbnailImage != '' ? hotel.thumbnailImage : defaultImageThumbnail} 300w, ${hotel.thumbnailImage != '' ? hotel.thumbnailImage : defaultImageThumbnail} 600w, ${
                  hotel.thumbnailImage != '' ? hotel.thumbnailImage : defaultImageThumbnail
               } 900w`"
               sizes="
                        (max-width: 300px) 300px,
                        (max-width: 600px) 600px,
                        (max-width: 900px) 900px,
                    "
               loading="lazy"
               @error="($event.target.src = defaultImageThumbnail), ($event.target.srcset = defaultImageThumbnail)"
               data-trigger-type="gallery"
               aria-expanded="false"
               :aria-controls="`collapse_hotelDetail-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
               @click="hotel.closedHotel?.isClosed ? undefined : getHotelDetail($event)"
               alt="" />
            <button
               class="hotel-card-gallery-trigger"
               data-trigger-type="gallery"
               aria-expanded="false"
               :aria-controls="`collapse_hotelDetail-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
               @click="hotel.closedHotel?.isClosed ? undefined : getHotelDetail($event)">
               <span><i class="gts-icon icon-gallery-photo icon-sm" /></span>
            </button>
         </div>
         <!-- HOTEL CARD CONTENT -->
         <div
            class="hotel-card-inner-section hotel-card-content"
            :class="hotel.closedHotel?.isClosed ? 'hotel-closed' : ''"
            data-trigger-type="accordion"
            @click="hotel.closedHotel?.isClosed ? undefined : getHotelDetail($event)">
            <div class="hotel-card-content-informations-wrapper">
               <div class="hotel-card-content-informations">
                  <!-- HOTEL TITLE AND SCORE  -->
                  <div class="hotel-title-wrapper">
                     <span class="hotel-name">{{ hotel.name }}</span>
                  </div>

                  <!-- HOTEL LOCATION INFOS -->
                  <div class="hotel-location">
                     <span class="hotel-location"> {{ hotel.location.address }}</span>
                  </div>
                  <!-- HOTEL STARS -->
                  <!-- {{ hotel.score }} -->
                  <div class="hotel-stars" v-if="hotel.score.star != 0 || hotel.hotelStarCategory == 1">
                     <i v-for="(item, index) in hotel.score.star" :key="'activeStar-' + index" class="gts-icon icon-star active"></i>
                     <i v-for="(item, index) in 5 - hotel.score.star" :key="'star' + index" class="gts-icon icon-star"></i>
                  </div>
                  <div class="hotel-stars" v-else-if="hotel.hotelStarCategory > 1">
                     <div class="Non-star-hotels">
                        <div class="special-category" v-if="hotel.hotelStarCategory == 2">
                           <i class="gts-icon icon-Polygon_45"></i>
                           <span>{{ $t("hotelCard_lblSpecialCategory") }}</span>
                        </div>
                        <div class="boutq-hotel" v-else>
                           <i class="gts-icon icon-Polygon_44"></i>
                           <span>{{ $t("hotelCard_lblBoutiqueHotel") }}</span>
                        </div>
                     </div>
                  </div>

                  <!-- Parçalı ödeme enabled ise vif eklencek -->

                  <div class="gts-partial-payment">
                     <div class="partial-payment" v-if="hotelItem.isPartialPaymentExist">
                        <div class="partial-payment-icon-container">
                           <div id="partial-payment-icon" class="gts-icon icon-partial-payment"></div>
                        </div>
                        <div class="partial-payment-text">
                           <span>{{ $t("hotelCard_lblPartialPayment") }}</span>
                        </div>
                     </div>
                     <div class="gts-ribbon" v-if="hotelItem.price.onUsContract && !isRecommended && hotelItem.price.onUs"></div>
                  </div>
               </div>
            </div>

            <!-- FACILITIES -->
            <div class="hotel-card-content-facilities" data-trigger-type="informations">
               <div class="facility-item" v-for="(hotelFacilityItem, key, index) in hotel.topFacilities" :key="index">
                  <!-- <i class="gts-icon" :class="'icon-dummy-facilities-' + index" /> -->

                  <img :src="key | facilitiesUrl" alt="" @error="$event.target.src = `${$constants.cdn}/hotel_facility/no_icon.svg`" />
                  <span class="facility-item-name"> {{ hotelFacilityItem }}</span>
               </div>
            </div>
         </div>

         <!-- HOTEL CARD PRICE INFOS -->
         <div class="hotel-card-inner-section hotel-card-price-info" data-trigger-type="searchRoom" @click="hotel.closedHotel?.isClosed ? undefined : getHotelDetail($event)">
            <template v-if="hotel.closedHotel?.isClosed">
               <div class="hotel-card-price-info-wrapper closed">
                  <div class="hotel-price-info-inner">
                     <!-- otel kapalı badge'i -->
                     <div class="hotel-price-info-item">
                        <UIInfoBadge :className="'HotelStatus'" :modifier="'--closed'" :text="'CLOSED'" />
                     </div>
                     <!-- otel kapalı badge'i -->
                     <!-- otel kapalı notu  -->
                     <div class="hotel-closed-note">{{ hotel.closedHotel.description }}</div>

                     <!-- İncelenecek -->
                     <div class="hotel-price-info-item temporary-spacer">
                        <UIButton :notRounded="true" :text="$t('hotelCard_btnSearchRoom').toUpperCase()" />
                     </div>
                     <!-- otel kapalı notu  -->
                  </div>
                  <!-- otel kapalı tarihleri -->
                  <div class="hotel-price-info-date">
                     <div class="closing-date">
                        <span>{{ "Closing Date" }}</span>
                        <span class="date">{{ hotel.closedHotel.fromDate | FormatterDate }}</span>
                     </div>
                     <div class="opening-date">
                        <span>{{ "Opening Date" }}</span>
                        <span class="date">{{ hotel.closedHotel.toDate | FormatterDate }}</span>
                     </div>
                  </div>
                  <!-- otel kapalı tarihleri -->
               </div>
            </template>
            <template v-else-if="hotel.restrictionType != 1">
               <div class="hotel-card-restrictions-wrapper">
                  <i :class="isRecommended ? 'filter-color' : ''"></i>
                  <span :class="isRecommended ? 'restrictions-info-txt filter-color' : 'restrictions-info-txt'">
                     {{ handlerRestrictionsFMT(hotel.restrictionValue, hotel.restrictionType) }}
                  </span>
               </div>
            </template>
            <template v-else>
               <div class="hotel-card-price-info-wrapper">
                  <div class="hotel-price-info-inner" v-if="!hotel.price.minStay">
                     <template v-if="!hotel.price.minStay">
                        <div class="hotel-card-inner-section hotel-card-tag-wrappers hotel-discount-info" v-if="hotel.specialOffer">
                           <span class="hotel-card-tag">{{ $t("hotelCard_lblDiscounted") }}</span>
                        </div>
                     </template>

                     <div class="hotel-price-info-item gts-direct" v-if="hotelItem.price.onUsContract && hotelItem.price.onUs">
                        <!-- :modifier="isRecommended ? '--direct-recommended' : '--direct'" -->

                        <UIInfoBadge :className="'HtlProviderInfo'" :modifier="isRecommended ? '--direct' : '--direct'" :text="'GTS DIRECT'" />
                     </div>
                     <div class="hotel-price-info-item gts-provider" v-else>
                        <UIInfoBadge :className="'HtlProviderInfo'" :modifier="'--provider'" :text="'PROVIDER'" />
                     </div>
                     <div class="hotel-price-info hotel-price-info-item direct" :class="hotel.specialOffer ? 'deal-price' : ''">
                        <template v-if="hotelItem.price.onUsContract && hotelItem.price.onUs">
                           <span
                              class="hotel-card-discount"
                              v-if="hotel.price.originalAmount > hotel.price.totalAmount"
                              :class="hotel.price.originalAmount > hotel.price.totalAmount && !isRecommended ? 'discountedPrice' : 'discountedPriceNonRec'">
                              {{ hotel.price.originalAmount | price(hotel.price.currency) }}
                           </span>
                        </template>

                        <span class="hotel-card-discount-price" :class="hotel.price.originalAmount > hotel.price.totalAmount && !isRecommended ? 'discountedPrice' : ''">
                           {{ hotel.price.totalAmount | price(hotel.price.currency) }}
                        </span>
                     </div>

                     <div class="hotel-cta-group hotel-price-info-item">
                        <UIButton
                           className="default"
                           :notRounded="true"
                           :text="$t('hotelCard_btnSearchRoom').toUpperCase()"
                           aria-expanded="false"
                           :aria-controls="`collapse_hotelDetail-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`" />
                     </div>
                  </div>
                  <div class="hotel-price-info-inner" v-if="hotel.price.minStay">
                     <div class="hotel-availability-datepicker hotel-price-info-item">
                        <date-range-picker
                           class="gts-date-range-wrapper"
                           ref="picker"
                           :opens="datePickerConfig.opens"
                           :ranges="datePickerConfig.ranges"
                           :autoApply="datePickerConfig.autoApply"
                           :locale-data="datePickerConfig.localeDate"
                           :minDate="datePickerConfig.minDate"
                           :dateFormat="dateFormat"
                           v-model="dateRange">
                           <template v-slot:input="picker">
                              <input type="hidden" :value="picker" />
                              <UIButton className="default" text="müsaitlik takvimi" />
                           </template>
                           <div slot="footer" class="gts-date-range-footer">
                              <div class="gts-date-range-footer-inner">
                                 <ul class="public-holidays-list">
                                    <li class="public-holidays-list-item" v-for="(publicHoliday, index) in publicHolidays" :key="index">
                                       <span>
                                          <strong>{{ publicHoliday.name }} - </strong>{{ publicHoliday.date | onlyDay }}
                                          {{ publicHoliday.date | onlyMonth }}
                                       </span>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </date-range-picker>
                     </div>
                  </div>
               </div>
            </template>
         </div>
      </div>

      <div
         :class="isCardShown ? 'collapse show' : 'collapse'"
         v-cloak
         class="hotel-card-inner-section hotel-detail-collapse"
         :id="`collapse_hotelDetail-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
         :aria-labelledby="`collapse_hotelDetail-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`">
         <div class="hotel-detail-inner">
            <div class="hotel-detail-content-tab-wrapper">
               <div class="hotel-detail-content-tab-inner">
                  <ul class="hotel-detail-content-tab-list nav nav-tabs" id="tab_hotelDetailContent" role="tablist">
                     <li class="hotel-detail-content-tab-list-item nav-item" role="presentation">
                        <a
                           class="nav-link active"
                           id="informations-tab"
                           data-bs-toggle="tab"
                           :href="`#informations-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                           role="tab"
                           :aria-controls="`#informations-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                           aria-selected="true"
                           >{{ $t("hotelCard_tabInfo") }}</a
                        >
                     </li>
                     <template>
                        <li class="hotel-detail-content-tab-list-item nav-item" role="presentation">
                           <a
                              class="nav-link"
                              id="gallery-tab"
                              data-bs-toggle="tab"
                              :href="`#gallery-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                              role="tab"
                              :aria-controls="`#gallery-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                              aria-selected="false"
                              >{{ $t("hotelCard_tabPhotoGallery") }}</a
                           >
                        </li>
                     </template>
                     <li class="hotel-detail-content-tab-list-item nav-item" role="presentation">
                        <a
                           class="nav-link"
                           id="rooms-tab"
                           data-bs-toggle="tab"
                           :href="`#rooms-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                           role="tab"
                           :aria-controls="`#rooms-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                           aria-selected="false"
                           >{{ $t("hotelCard_tabRooms") }}</a
                        >
                     </li>
                     <i role="presentation" class="close-item gts-icon icon-close-rounded" @click="closeDetail"></i>
                  </ul>
                  <div class="hotel-detail-content-tab-content tab-content" id="tabPane_hotelDetailContent">
                     <div
                        class="hotel-detail-content-tab-content-item tab-pane fade show active informations-tab"
                        :id="`informations-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                        role="tabpanel"
                        aria-labelledby="informations-tab">
                        <div class="hotel-detail-content-tab-content-item-inner">
                           <div class="hotel-description-content-section hotel-content-section" v-if="this.hotel.content.descriptions" v-cloak>
                              <div class="hotel-content-section-content">
                                 <div
                                    class="description-content"
                                    :class="isReadMoreActive ? 'line-clamp-shrinked' : 'line-clamp'"
                                    v-for="(hotelDescriptionItem, index) in hotel.content.descriptions"
                                    :key="'hdesc-' + index">
                                    <span class="description-content__title">{{ hotelDescriptionItem.title }}</span>
                                    <span class="description-content__description">{{ hotelDescriptionItem.description }}</span>
                                 </div>
                                 <span class="btn_readMore" @click="handlerReadMore" v-if="hotelDescriptionOffsetStatus">{{
                                    isReadMoreActive ? $t("hotelCard_btnReadMore") : $t("hotelCard_btnReadLess")
                                 }}</span>
                              </div>
                           </div>
                           <div class="hotel-facilities-content-section hotel-content-section">
                              <div v-for="(matchedFacilitiesListItem, index) in matchedFacilitiesList" :key="index" v-cloak>
                                 <template v-if="index <= loadedFacilitiesCount">
                                    <div class="hotel-content-section-title">
                                       <h4 v-if="currentLang == 'tr'">{{ matchedFacilitiesListItem.nameTr }}</h4>
                                       <h4 v-if="currentLang == 'en'">{{ matchedFacilitiesListItem.nameEn }}</h4>
                                       <h4 v-if="currentLang == 'de'">{{ matchedFacilitiesListItem.nameDe }}</h4>
                                    </div>
                                    <div class="hotel-content-section-content">
                                       <div class="hotel-content-facilities-list">
                                          <div class="hotel-content-facilities-list-item" v-for="(facilityItem, index) in matchedFacilitiesListItem.facilities" :key="index">
                                             <div class="hotel-content-facilities-list-item-icon">
                                                <img :src="facilityItem.id | facilitiesUrl" alt="" @error="$event.target.src = `${$constants.cdn}/hotel_facility/no_icon.svg`" />
                                             </div>
                                             <div class="hotel-content-facilities-list-item-description">
                                                <span v-if="currentLang == 'tr'">{{ facilityItem.nameTr }}</span>
                                                <span v-if="currentLang == 'en'">{{ facilityItem.nameEn }}</span>
                                                <span v-if="currentLang == 'de'">{{ facilityItem.nameDe }}</span>

                                                <p>{{ facilityItem.description }}</p>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </template>
                              </div>
                              <div class="hotel-facilities-cta-group">
                                 <span class="btn_showMoreFacility" @click="handlerShowOtherFacility" v-if="loadedFacilitiesCount == 1">
                                    {{ $t("hotelCard_btnFacilityShowMore") }}<i class="icon-arrow-rounded-down"></i>
                                 </span>
                                 <span class="btn_showMoreFacility" @click="handlerShowOtherFacility" v-else> {{ $t("hotelCard_btnFacilityShowLess") }}<i class="icon-arrow-rounded-up"></i> </span>
                              </div>
                           </div>
                           <div class="hotel-map-content-section hotel-content-section">
                              <div class="hotel-content-section-title">
                                 <h4>{{ $t("hotelCard_lblLocationTitle") }}</h4>
                              </div>
                              <div class="hotel-content-section-content">
                                 <div class="hotel-map-wrapper">
                                    <div class="hotel-map-inner">
                                       <iframe
                                          :src="`https://www.google.com/maps/embed/v1/place?key=AIzaSyC6KlW4LBYXw206YxNZoV8VCWhnWocfN-w&q=${hotel.location.coordinate.lat},${hotel.location.coordinate.lon}`"
                                          width="100%"
                                          height="450"
                                          style="border: 0"
                                          allowfullscreen=""
                                          loading="lazy"
                                          referrerpolicy="no-referrer-when-downgrade"></iframe>
                                       <!-- <div class="static-map">
                                                        <img :src="`https://maps.googleapis.com/maps/api/staticmap?center=${hotel.location.coordinate.lat},${hotel.location.coordinate.lon}&zoom=12&size=400x400&key=AIzaSyC6KlW4LBYXw206YxNZoV8VCWhnWocfN-w`" loading="lazy" alt="" />
                                                        <UIButton className="default" :text="$t('common_show')" />
                                                    </div> -->
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <template>
                        <div
                           class="hotel-detail-content-tab-content-item tab-pane fade gallery-tab"
                           :id="`gallery-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                           role="tabpanel"
                           aria-labelledby="gallery-tab">
                           <div class="hotel-detail-content-tab-content-item-inner">
                              <GtsSlider v-if="hotel.images" :hotelImages="hotel.images" withMiniGallery withLargeGallery />
                              <p v-else>This hotel has no photo content !</p>
                           </div>
                        </div>
                     </template>
                     <div
                        class="hotel-detail-content-tab-content-item tab-pane fade room-tab"
                        :id="`rooms-${isRecommended ? `r${hotel.id}` : `h${hotel.id}`}`"
                        role="tabpanel"
                        aria-labelledby="rooms-tab">
                        <div class="hotel-detail-content-tab-content-item-inner">
                           <div class="rooms-wrapper">
                              <div class="rooms-section" v-if="lazyLoadStatus">
                                 <template v-for="(roomGroupItem, key, index) in hotel.roomGroups">
                                    <div class="rooms-section-item" :key="'rg-' + index">
                                       <!-- {{ roomGroupItem.lazyLoad }} -->
                                       <div class="room-section-header">
                                          <span>{{ roomGroupItem.index }}. {{ $t("hotelCard_room") }}</span>
                                          <div class="visitors-container">
                                             <span>{{ "(" }}</span>
                                             <span class="adult">{{ roomGroupItem.adult }} {{ $t("common_adult") }}</span>
                                             <span class="child" v-if="roomGroupItem.child != 0">{{ "," }} {{ roomGroupItem.child }} {{ $t("common_child") }} </span>
                                             <span>{{ ")" }}</span>
                                          </div>
                                       </div>
                                       <div class="rooms-list" :id="`rc-${roomGroupItem.index}`">
                                          <div class="rooms-list --no-matching-rooms" v-if="Object.keys(roomControl).length && roomControl[roomGroupItem.index].isTextVisible">
                                             {{ $t("hotelCard_noMatchingBoardType") }}
                                          </div>

                                          <div class="rooms-list-item active" v-for="(roomItem, roomItemKey, roomItemIndex) in roomGroupItem.rooms" :key="roomItemIndex">
                                             <!-- <div>*{{ roomItem.name }}, {{ roomItemIndex }}, {{ roomItemKey }}</div> -->

                                             <RoomCard
                                                :handlerClickedRoomIndex="handlerClickedRoomIndex"
                                                :roomDetail="roomItem"
                                                :hotelId="searchQuery.hotelId"
                                                :hotel-name="hotel.name"
                                                :channels="hotel.channels"
                                                :roomItemCode="roomItem.roomIdentifier"
                                                :isDynamicPackage="roomItem.packageCode != null ? true : false"
                                                :roomGroupIndex="roomGroupItem.index"
                                                :isRecommendedHotelRoom="isRecommended"
                                                v-show="!isRoomSelected ? roomItemIndex < roomGroupItem.lazyLoad : true" />
                                          </div>

                                          <template v-if="!isRoomSelected">
                                             <div class="load-more-room" v-if="Object.keys(roomGroupItem.rooms).length > roomGroupItem.lazyLoad" @click="loadMoreRoom(key)">
                                                {{ $t("hotelRoomCard_lblLoadMore") }}

                                                <span> ({{ Object.keys(roomGroupItem.rooms).length - roomGroupItem.lazyLoad }} {{ $t("hotelRoomCard_lblRoomCountTxt") }}) </span>
                                             </div>
                                          </template>
                                       </div>
                                    </div>
                                 </template>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { hotelService } from "@/service/index.js";
// import { priceMap } from "@/helper/hotel.js";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import "@/assets/css/datepicker.scss";

import RoomCard from "@/components/structural/hotel/search/RoomCard.vue";
import GtsSlider from "@/components/utils/GtsSlider.vue";
import UIButton from "@/components/unitary/Button.vue";
import UIInfoBadge from "@/components/unitary/InfoBadge.vue";
import defaultImageThumbnail from "@/assets/images/noimg.svg";
import i18n from "@/fmt/i18n.js";
import Popup from "@/gts-popup.js";

export default {
   name: "HotelCardComponent",
   components: {
      DateRangePicker,
      GtsSlider,
      UIButton,
      UIInfoBadge,
      RoomCard,
   },
   props: {
      index: Number,
      hotelItem: { type: Object },
      isRecommended: { type: Boolean },
      totalHotelCount: Number,
   },
   data() {
      return {
         visibleRoomCount: 3,
         lazyLoadStatus: true,
         category: 1,
         hotel: this.hotelItem,
         clickedRoomIndex: 0,
         roomControl: {},
         isTextVisible: false,
         datePickerConfig: {
            opens: "center",
            autoApply: true,
            ranges: false,
            localeDate: {
               format: "dd.mm.yyyy",
               daysOfWeek: ["Paz", "Pts", "Sal", "Çar", "Per", "Cum", "Cts"],
               monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
            },
            minDate: new Date(),
         },
         dateRange: {
            startDate: moment(),
            endDate: moment().add(3, "days"),
         },
         StopDates: [
            { name: "StopDate-1", date: moment().add(20, "days") },
            { name: "StopDate-2", date: moment().add(21, "days") },
            { name: "StopDate-3", date: moment().add(22, "days") },
            { name: "StopDate-4", date: moment().add(23, "days") },
            { name: "StopDate-5", date: moment().add(30, "days") },
         ],
         publicHolidays: [
            { name: "holiday-1", date: moment().add(35, "days") },
            { name: "holiday-2", date: moment().add(36, "days") },
            { name: "holiday-3", date: moment().add(37, "days") },
            { name: "holiday-4", date: moment().add(38, "days") },
            { name: "holiday-5", date: moment().add(39, "days") },
         ],
         searchQuery: {
            searchUuid: this.$store.state.hotel.searchUuid,
            hotelId: null,
            recommended: this.isRecommended ? true : false,
         },
         isReadMoreActive: true,
         loadedFacilitiesCount: 1,
         matchedFacilitiesListLength: 0,
         defaultImageThumbnail: defaultImageThumbnail,
         isDetailActive: false,
         isCardShown: false,
         hotelCardRandomId: 0,
         hotelDescriptionOffsetStatus: false,
         currentLang: "",
      };
   },
   created() {
      var self = this;
      self.searchQuery.hotelId = self.hotel.id;
      self.hotelCardRandomId = Math.floor(1000 + Math.random() * 9000);
      self.currentLang = i18n.locale;
   },
   computed: {
      isRoomSelected() {
         const rooms = this.$store.state.hotel.basketResponse.rooms;
         return rooms && typeof rooms === "object" && Object.keys(rooms).length > 0;
      },
      matchedFacilitiesList() {
         const self = this;
         const initStoreFacilitiesList = this.$store.state.hotel.facilitiesArr;
         let cloneFacilitiesGroupList = [];
         if (self.isDetailActive) {
            self.hotel.facilityGroups.map((facilityGroupItem) => {
               facilityGroupItem.facilities.map((facilityItem, index) => {
                  initStoreFacilitiesList.map((initStoreFacilitiesListItem) => {
                     if (facilityItem.id == initStoreFacilitiesListItem.id) {
                        facilityGroupItem.facilities[index] = initStoreFacilitiesListItem;
                        facilityGroupItem.facilities[index].description = facilityItem.description;

                        facilityGroupItem.nameTr = initStoreFacilitiesListItem.groupNameTr;
                        facilityGroupItem.nameEn = initStoreFacilitiesListItem.groupNameEn;
                        facilityGroupItem.nameDe = initStoreFacilitiesListItem.groupNameDe;
                     }
                  });
               });

               cloneFacilitiesGroupList.push(facilityGroupItem);
            });

            self.matchedFacilitiesListLength = cloneFacilitiesGroupList.length;

            return cloneFacilitiesGroupList;
         } else {
            return null;
         }
      },
   },
   methods: {
      loadMoreRoom(key) {
         this.lazyLoadStatus = false;
         this.$set(this.hotel.roomGroups[key], "lazyLoad", this.hotel.roomGroups[key].lazyLoad + this.visibleRoomCount);
         this.lazyLoadStatus = true;
      },
      scrollToTop() {
         // Hotel carda tıklanıldığında roomDetail'si ekranda ortalar.
         const clickedComponent = this.$refs.clickedComponent;
         const distanceFromTop = clickedComponent.getBoundingClientRect().top + window.pageYOffset;
         window.scrollTo({ top: distanceFromTop, behavior: "smooth" });
      },
      handlerRestrictionsFMT(val, type) {
         const typeEnum = this.$options.filters.EHtlPriceRestrictionType(type);
         const willReturn = this.$t(`hotelCard_lbl${typeEnum}`).replace("#VALUE#", val);

         return willReturn;
      },

      setDeactiveRoomCount(roomIndexes) {
         for (let i = 1; i <= roomIndexes.length; i++) {
            const parent = document.getElementById(`rc-${i}`);
            const childNodes = parent.querySelectorAll(".room-card-wrapper");
            setTimeout(() => {
               let counter = 0;
               Array.from(childNodes).forEach((child) => {
                  if (!child) return;
                  if (child.classList.contains("d-none")) {
                     this.roomControl[i].deActiveRoomCount = ++counter;
                  }
                  if (counter == this.roomControl[i].roomCount) this.roomControl[i].isTextVisible = true;
                  else this.roomControl[i].isTextVisible = false;
               });
            }, 500);
         }
      },
      handlerClickedRoomIndex(roomIndex) {
         roomIndex == 1 ? (self.clickedRoomIndex = roomIndex + 1) : (self.clickedRoomIndex = roomIndex - 1);
      },

      dateFormat(classes, date) {
         var self = this;

         for (var i = 0; i < self.StopDates.length; i++) {
            if (moment(date).format("DD.MM.YYYY") == moment(self.StopDates[i].date).format("DD.MM.YYYY")) {
               classes.disabled = true;
            }
         }

         for (var c = 0; c < self.publicHolidays.length; c++) {
            if (moment(date).format("DD.MM.YYYY") == moment(self.publicHolidays[c].date).format("DD.MM.YYYY")) {
               classes.publicHolidays = true;
            }
         }

         return classes;
      },
      getHotelDetail(e) {
         e.preventDefault();
         var self = this;
         this.scrollToTop();
         if (!self.isDetailActive) {
            hotelService.hotelDetail(self.searchQuery).then((response) => {
               if (!response.result.success) {
                  Popup.result(response.result);

                  return;
               } else {
                  var hotelDetailResponse = this.isRecommended ? response.recommendedHotels[self.searchQuery.hotelId] : response.hotels[self.searchQuery.hotelId];
                  self.hotel.roomGroups = hotelDetailResponse.roomGroups;
                  Object.keys(self.hotel.roomGroups).forEach((key) => {
                     self.hotel.roomGroups[key].lazyLoad = this.visibleRoomCount;
                  });
                  self.hotel.channels = response.channels;
                  self.hotel.facilityGroups = hotelDetailResponse.facilityGroups;
                  self.hotel.content.descriptions = hotelDetailResponse.descriptions;
                  if (self.hotel.content.descriptions != null) {
                     self.hotelDescriptionOffsetStatus = self.hotel.content.descriptions.length > 2 ? true : false;
                  } else {
                     self.hotelDescriptionOffsetStatus = "";
                  }
                  if (hotelDetailResponse.images?.length) {
                     self.hotel.images = hotelDetailResponse.images
                        .filter((item) => item.small)
                        .map((i) => {
                           return {
                              small: i.sml.includes("S") ? i.url.replace("{0}", "S") : null,
                              medium: i.sml.includes("M") ? i.url.replace("{0}", "M") : null,
                              large: i.sml.includes("L") ? i.url.replace("{0}", "L") : null,
                           };
                        });
                  }
                  self.isDetailActive = true;
                  self.isCardShown = true;
               }
            });
         }
         const selfItemElementWrapper = document.querySelector(`[data-hotel-card-id="${self.$el.attributes["data-hotel-card-id"].value}"]`);
         const triggerType = e.currentTarget.attributes["data-trigger-type"].value;
         const hotelContentTabList = selfItemElementWrapper.querySelectorAll(".hotel-detail-content-tab-list > .hotel-detail-content-tab-list-item");
         const hotelDetailContentTabList = selfItemElementWrapper.querySelectorAll(".hotel-detail-content-tab-content > .hotel-detail-content-tab-content-item");

         hotelDetailContentTabList.forEach((tabItem) => {
            tabItem.classList.remove("active", "show");
         });

         hotelContentTabList.forEach((element) => {
            const activeTab = element.children[0].classList.contains("active");
            element.children[0].classList.remove("active");
            if (element.children[0].id == "gallery-tab" && triggerType == "gallery") {
               if (activeTab) {
                  self.isCardShown = false;
               } else {
                  self.isCardShown = true;
                  element.children[0].classList.add("active");
                  selfItemElementWrapper.querySelector(".hotel-detail-content-tab-content > .gallery-tab").classList.add("active", "show");
               }
            } else if (element.children[0].id == "rooms-tab" && triggerType == "searchRoom") {
               if (activeTab) {
                  self.isCardShown = false;
               } else {
                  self.isCardShown = true;
                  element.children[0].classList.add("active");
                  selfItemElementWrapper.querySelector(".hotel-detail-content-tab-content > .room-tab").classList.add("active", "show");
               }
            } else if (element.children[0].id == "informations-tab" && triggerType == "informations") {
               if (activeTab) {
                  self.isCardShown = false;
               } else {
                  self.isCardShown = true;
                  element.children[0].classList.add("active");
                  selfItemElementWrapper.querySelector(".hotel-detail-content-tab-content > .informations-tab").classList.add("active", "show");
               }
            } else if (element.children[0].id == "informations-tab" && triggerType == "accordion") {
               self.isCardShown = !self.isCardShown;
               if (self.isCardShown) {
                  element.children[0].classList.add("active");
                  selfItemElementWrapper.querySelector(".hotel-detail-content-tab-content > .informations-tab").classList.add("active", "show");
               }
            }
         });
      },
      closeDetail() {
         this.isCardShown = false;
      },
      handlerReadMore() {
         var self = this;
         self.isReadMoreActive = !self.isReadMoreActive;
      },
      handlerShowOtherFacility() {
         const self = this;
         if (self.loadedFacilitiesCount == self.matchedFacilitiesListLength) {
            self.loadedFacilitiesCount = 1;
         } else {
            self.loadedFacilitiesCount = self.matchedFacilitiesListLength;
         }
      },
   },
};
</script>

<style lang="scss">
i.icon-arrow-rounded-down {
   cursor: pointer;
   background-color: transparent !important;
   width: 32px !important;
   height: 32px !important;
   min-width: 32px;
   min-height: 32px;
   flex-shrink: 0;
   display: block;
   background-size: contain;
   background-repeat: no-repeat;
   background-position: 50%;
   background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc1MC4wOTQgLTI4NSkiPjxjaXJjbGUgZGF0YS1uYW1lPSJFbGxpcHNlIDI4MiIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTAuMDk0IDI4NSkiIGZpbGw9IiNlOGU4ZTgiLz48cGF0aCBkPSJNNzcyLjgwOSAyOTguMjM4YTEuNDU5IDEuNDU5IDAgMDAtLjIyMy0uNzkxLjkyOC45MjggMCAwMC0uNjU3LS40NDIuODM3LjgzNyAwIDAwLS43MS4yODFsLTUuMTkxIDUuNTQxLTUuMi01LjM0MWEuODMyLjgzMiAwIDAwLS43MTMtLjI3LjkzNi45MzYgMCAwMC0uNjU1LjQ1MyAxLjQ3MiAxLjQ3MiAwIDAwLS4yMzYuOTQzIDEuMzQ2IDEuMzQ2IDAgMDAuMzgyLjg2Mmw1LjgxMyA1Ljk3MmEuODEzLjgxMyAwIDAwMS4yMyAwbDUuODEyLTYuMTgxYTEuNDEgMS40MSAwIDAwLjM0OC0xLjAyN3oiIGZpbGw9IiM0ZjUyNTciLz48L2c+PC9zdmc+);

   &.large-arrow-icon {
      width: 28px !important;
      height: 28px !important;

      flex-shrink: 0;
   }
   &.deg90 {
      transform: rotate(90deg);
   }
   &.deg270 {
      transform: rotate(270deg);
   }
   &.deg180 {
      transform: rotate(180deg);
   }
}
</style>

<style lang="scss" scoped>
.hotel-card-wrapper {
   background-color: var(--surface-level-2);

   /* box-shadow: var(--gray-1000-alpha-75) 0px 1px 2px 0px; */
   box-shadow: var(--gts-box-shadow);
   border-radius: 12px;
   color: var(--gray-700);

   &.best-price-hotel,
   &.early-booking-hotel {
      background-color: var(--blue-400);
      color: white;

      .hotel-name > h2,
      .hotel-info-item > span,
      .hotel-info-item > span > i {
         width: 16px !important;
         color: white !important;
      }
   }
   .hotel-card-inner {
      display: flex;
      flex-direction: column;
      position: relative;

      padding: 0.25rem;

      @media (min-width: 768.99px) and (max-width: 991.99px) {
         flex-direction: column;
      }
      @media (min-width: 992px) {
         flex-direction: row;
      }
      .hotel-card-inner-section {
         cursor: pointer;
         position: relative;

         &.hotel-closed {
            opacity: 0.5;
         }

         &.hotel-card-tag-wrapper {
            width: fit-content;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            background-color: var(--accent-primary);
            padding: 0.35rem 1rem;
            border-top-left-radius: 12px;
            border-bottom-right-radius: 16px;

            span.hotel-card-tag {
               font-weight: 600;
               font-size: var(--small);
            }

            &.addon-tag {
               background-color: var(--purple-400);
               //color: var(--gray-50);
               color: var(--gray-0);
            }
         }
         &.hotel-discount-info {
            margin-bottom: 0.5rem;
            font-weight: 500;
            font-size: var(--small);
         }
         &.hotel-card-thumbnail {
            margin-top: 12px;
            width: 100%;
            height: 210px;
            flex-shrink: 0;
            border-radius: 12px;
            background: lightblue;
            overflow: hidden;
            border-radius: 1rem;

            // display: none !important;

            @media (max-width: 576px) {
               width: 100%;
            }

            @media (min-width: 768px) and (max-width: 991px) {
               width: 100%;
            }

            @media (min-width: 992px) {
               width: 180px;
               margin-left: 0.5rem;
            }

            @media (min-width: 1600px) {
               width: 320px;
               margin-left: 0.5rem;
            }

            img {
               object-fit: cover;
               width: 100%;
               cursor: pointer;
               height: 100%;
               max-height: 100%;
               max-width: 100%;
            }
            button.hotel-card-gallery-trigger {
               position: absolute;
               z-index: 1;
               bottom: 0.5rem;
               right: 0.5rem;
               background-color: var(--gray-200) !important;
               padding: 0.5rem;
               border-radius: 0.5rem;
            }
         }
         &.hotel-card-content2 {
            width: 100%;

            border-right: 1px solid var(--gray-200);
            cursor: pointer;
            display: flex;
            flex-direction: column;
            padding: 1.5rem;

            .hotel-card-content-inner {
               position: relative;
               display: flex;
               flex-direction: column;
               justify-content: flex-end;
               height: 100%;
            }

            .hotel-content-title {
               align-items: center;
               position: absolute;
               top: 0;
               span.hotel-name {
                  font-size: 1.5rem;
                  font-weight: 600;
               }
               .hotel-star {
                  display: flex;

                  i {
                     width: 16px !important;
                     margin-right: 4px;
                     opacity: 0.3;

                     &:last-child {
                        margin-right: 0;
                     }
                  }
                  i.active {
                     opacity: 1;
                     filter: invert(74%) sepia(100%) saturate(805%) hue-rotate(358deg) brightness(103%) contrast(103%);
                  }
               }
            }
            .hotel-content-info {
               margin-bottom: 16px;

               .hotel-content-info-inner {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  .hotel-info-item {
                     margin-right: 12px;

                     & > span {
                        width: 100%;
                        display: inline-flex;
                        align-items: center;
                        font-size: 12px;

                        i {
                           width: 16px !important;
                           height: 16px !important;
                           margin-right: 8px;
                        }

                        span {
                           width: 100%;
                           overflow: hidden;
                           white-space: nowrap;
                           text-overflow: ellipsis;
                        }
                     }

                     &:last-child {
                        margin-right: 0;
                     }

                     &.hotel-location-info {
                        width: 90%;

                        & > span {
                           i {
                              color: var(--orange-400);
                           }
                        }
                     }
                     &.hotel-minStay-info {
                        color: var(--red-500);
                     }
                     &.hotel-maxStay-info {
                        color: var(--green-600);
                     }
                     &.hotel-stopStay-info {
                        color: var(--blue-600);
                     }
                  }
               }
            }
            .hotel-content-facilities {
               .hotel-facilities-inner {
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  & > span {
                     display: flex;
                     align-items: center;
                     width: auto;
                     max-width: 120px;

                     margin-right: 8px;

                     &:last-child {
                        margin-right: 0;
                     }
                  }
                  & > i {
                     margin: 3px;
                     padding: 3px;
                     border-right: 1px solid var(--gray-200);
                  }
                  & > i:last-child {
                     border: none !important;
                  }
               }
            }
         }
         &.hotel-card-content {
            position: relative;
            width: 100%;
            padding: 0.75rem;
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;

            @media (min-width: 576px) {
               padding: 1.5rem;
            }

            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            &:after {
               content: "";
               position: absolute;
               right: 0;
               top: 0px;
               bottom: 0px;
               border: 1px solid var(--gray-300);
               opacity: 1;
            }

            .hotel-card-content-informations {
               .hotel-title-wrapper {
                  margin-top: 0.75rem;
                  span.hotel-name {
                     font-size: 1.35rem;
                     font-weight: 600;
                  }
               }
               .hotel-stars {
                  display: flex;
                  margin-top: 0.5rem;
                  i {
                     width: 15px !important;
                     margin-right: 4px;
                     opacity: 0.3;

                     &:last-child {
                        margin-right: 0;
                     }
                  }
                  i.active {
                     opacity: 1;
                     filter: invert(74%) sepia(100%) saturate(805%) hue-rotate(358deg) brightness(103%) contrast(103%);
                  }
                  .Non-star-hotels {
                     display: flex;
                     justify-content: center;
                     height: 2rem;
                     width: 8rem;
                     border-radius: 8px;
                     color: var(--blue-800);
                     font-weight: 500;
                     background-color: var(--yellow-400);
                     .boutq-hotel {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        span {
                           font-size: 12px;
                        }
                        i {
                           margin-bottom: 2px;
                        }
                     }
                     .special-category {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        span {
                           font-size: 12px;
                        }
                        i {
                           margin-bottom: 2px;
                        }
                     }
                  }
               }
               .hotel-location {
                  display: flex;
                  align-items: center;
                  margin-top: 0.25rem;
                  i {
                     filter: invert(62%) sepia(58%) saturate(1102%) hue-rotate(335deg) brightness(103%) contrast(101%);
                  }
                  span.hotel-location {
                     padding-left: 0.25rem;
                     text-decoration: underline;
                     font-size: var(--small);
                  }
               }
               .gts-partial-payment {
                  display: flex;
                  position: absolute;
                  right: 2rem;
                  top: 1.5rem;
                  @media (max-width: 576px) {
                     top: 5rem;
                  }
                  .partial-payment {
                     display: flex;
                     flex-direction: column;
                     margin-right: 1rem;
                     scale: 0.9;
                     transform-origin: top;

                     @media (max-width: 576px) {
                        scale: 0.6;
                     }

                     @media (min-width: 800px) and (max-width: 990px) {
                        scale: 0.8;
                     }

                     .partial-payment-icon-container {
                        display: flex;
                        justify-content: center;
                        z-index: 5;
                        #partial-payment-icon {
                           height: 75px !important;
                           width: 75px !important;
                        }
                     }

                     .partial-payment-text {
                        margin-top: -0.75rem;
                        display: flex;
                        height: 32px;
                        //color: var(--gray-50);
                        color: var(--txt-white);
                        background: var(--cyan-500);
                        border-radius: 1rem;
                        width: 140px;
                        span {
                           font-family: "Roboto", sans-serif;
                           font-weight: 400;
                           font-size: 15px;
                           margin: 0 auto;
                           margin-top: 4px;
                           height: 32px;
                           //color: var(--gray-50);
                           color: var(--gray-0);
                        }
                     }
                  }

                  .gts-ribbon {
                     width: 80px;
                     height: 112px;
                     background-image: url("data:image/svg+xml;base64,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");
                     @media (max-width: 576px) {
                        position: absolute;
                        left: -50px;
                        top: -80px;
                        scale: 0.5;
                     }
                     @media (min-width: 800px) and (max-width: 990px) {
                        position: absolute;
                        left: -81px;
                        top: -10px;
                        scale: 0.8;
                     }
                  }
               }
            }

            .hotel-card-content-facilities {
               display: flex;
               margin-top: 1.5rem;
               @media (max-width: 991px) {
                  justify-content: space-between;
               }

               .facility-item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  margin: 0 0.25rem;
                  border-right: 1px solid var(--gray-300);
                  padding-top: 0.35rem;
                  padding-bottom: 0.35rem;
                  padding-right: 1rem;

                  @media (min-width: 576px) {
                     flex-direction: row;
                     margin: 0 0.75rem;
                  }

                  &:first-child {
                     padding-left: 0 !important;
                     margin-left: 0 !important;
                  }
                  &:last-child {
                     border: none !important;
                  }

                  .facility-item-name {
                     font-family: Roboto;
                     font-size: var(--normal);
                     font-weight: 400;
                     padding-left: 0.5rem;
                     text-align: center;
                     margin-top: 0.5rem;
                     line-height: 1.3rem;
                     @media (min-width: 576px) {
                        text-align: left;
                     }
                  }
               }
               img {
                  width: 1.8rem;
                  height: 1.8rem;
               }
            }
         }
         &.hotel-card-price-info {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            width: 30%;
            max-width: 30%;
            padding: 0 12px;

            @media (max-width: 991px) {
               width: 100%;
               max-width: 100%;
               border-top: 1px solid var(--gray-300);
            }

            .hotel-card-restrictions-wrapper {
               padding: 1rem;
               height: 100%;
               display: flex;
               flex-direction: column;
               justify-content: center;
               align-items: center;
               .filter-color {
                  filter: brightness(1.5);
               }
               i {
                  display: flex;
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: cover;
                  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICA8ZyBpZD0iR3JvdXBfMTE2MzIiIGRhdGEtbmFtZT0iR3JvdXAgMTE2MzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTI0IC05NDQpIj4KICAgIDxnIGlkPSJHcm91cF8xMTYxMCIgZGF0YS1uYW1lPSJHcm91cCAxMTYxMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU0NC40NDYgOTU1LjExNCkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMDMzMyIgZGF0YS1uYW1lPSJQYXRoIDEwMzMzIiBkPSJNMjEuNzkyLDE0LjgyM2wtNi43NTMuODQ3TDE0LjgsMTYuNzlsMS4zMjcuMjQ1Yy44NjYuMjA3LDEuMDM4LjUxOS44NDksMS4zODNMMTQuOCwyOC42NDZjLS41NzIsMi42NDUuMzA5LDMuODksMi4zODMsMy44OWE2LjEwOCw2LjEwOCwwLDAsMCw0LjMyLTEuNzYzbC4yNi0xLjIyN2EzLjI2NywzLjI2NywwLDAsMS0yLjAyNC43MjVjLS44MTEsMC0xLjEwNi0uNTY5LS45LTEuNTcyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0LjYyNyAtNS43MTYpIiBmaWxsPSIjOTk5Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzEwMzM0IiBkYXRhLW5hbWU9IlBhdGggMTAzMzQiIGQ9Ik0yMS42NDgsMTAuODI0QTIuOTQ5LDIuOTQ5LDAsMSwxLDE4LjcsNy44NzUsMi45NDksMi45NDksMCwwLDEsMjEuNjQ4LDEwLjgyNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNC4yNzMgLTcuODc1KSIgZmlsbD0iIzk5OSIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IkVsbGlwc2VfMTMxNSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMTUiIGQ9Ik0yNCwyLjdBMjEuMywyMS4zLDAsMCwwLDguOTM5LDM5LjA2MSwyMS4zLDIxLjMsMCwwLDAsMzkuMDYxLDguOTM5LDIxLjE2MSwyMS4xNjEsMCwwLDAsMjQsMi43TTI0LDBBMjQsMjQsMCwxLDEsMCwyNCwyNCwyNCwwLDAsMSwyNCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUyNCA5NDQpIiBmaWxsPSIjOTk5Ii8+CiAgPC9nPgo8L3N2Zz4K");
                  width: 56px;
                  height: 56px;
               }
               span.restrictions-info-txt {
                  padding-top: 1rem;
                  color: var(--gray-500);
                  font-weight: 500;
                  text-align: center;
                  line-height: 1.15rem;
                  font-size: 15px;
                  &.filter-color {
                     color: white;
                  }
               }
            }
            .hotel-card-price-info-wrapper {
               margin-left: auto;
               display: flex;
               align-items: center;
               justify-content: right;
               height: 100%;

               &.closed {
                  display: flex;
                  flex-direction: column;
               }
               .hotel-price-info-date {
                  margin-left: auto;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  height: 80%;
                  .closing-date {
                     margin-left: auto;
                     margin-right: 2rem;
                     display: flex;
                     flex-direction: column;
                     width: auto;
                     .date {
                        margin-left: auto;
                        font-weight: 600;
                        opacity: 0.5;
                        font-size: var(--small);
                     }
                     span {
                        opacity: 0.5;
                        font-size: var(--small);
                     }
                  }
                  .opening-date {
                     display: flex;
                     flex-direction: column;
                     margin-left: auto;
                     margin-right: 2rem;
                     width: auto;
                     .date {
                        font-weight: 600;
                        margin-left: auto;
                        color: var(--green-600);
                        font-size: var(--small);
                     }
                     span {
                        color: var(--green-600);
                        font-size: var(--small);
                     }
                  }
               }
               .hotel-price-info-inner {
                  margin-left: auto;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                  height: 100%;

                  @media (max-width: 576px) {
                     flex-direction: column;
                     padding: 1rem;
                     gap: 0.75rem;
                     align-items: stretch;
                  }

                  @media (min-width: 577px) and (max-width: 991px) {
                     flex-direction: row;
                     padding: 1rem 0;
                     justify-content: space-between;
                  }

                  .hotel-closed-note {
                     @media (min-width: 991px) {
                        margin-left: auto;
                        margin-right: 2rem;
                        text-align: right;
                     }

                     width: 55%;
                     margin-top: 8px;
                     font-size: var(--xsmall);
                     white-space: pre-wrap;
                     word-wrap: break-word;
                     line-break: auto;
                     hyphens: auto;
                  }
                  .hotel-price-info-item {
                     .room-card-button {
                        height: 0;
                     }
                     &.temporary-spacer {
                        visibility: hidden;
                        margin-left: auto;
                        height: 0;
                        @media (min-width: 991px) {
                           margin-left: auto;
                           margin-right: 2rem;
                           padding-left: 2rem;
                        }
                     }
                     @media (min-width: 991px) {
                        margin-left: auto;
                        margin-right: 2rem;
                        padding-left: 2rem;
                     }

                     &.gts-direct {
                        @media (min-width: 991px) {
                           margin-left: auto;
                        }
                        @media (max-width: 576px) {
                           order: 1;
                        }
                     }
                     &.gts-provider {
                        @media (min-width: 991px) {
                           margin-left: auto;
                        }
                        @media (max-width: 576px) {
                           order: 1;
                        }
                     }
                     &.discount-color {
                        color: var(--cyan-500);
                     }
                     &.hotel-price-info {
                        span {
                           font-size: 1.75rem;
                           font-weight: 800;
                        }
                        @media (max-width: 576px) {
                           order: 2;
                           text-align: center;
                        }
                     }
                     &.hotel-cta-group {
                        margin-top: 12px;
                        @media (max-width: 576px) {
                           margin-top: 0;
                           order: 3;
                           ::v-deep button {
                              width: 100%;
                           }
                        }
                        @media (min-width: 577px) and (max-width: 991px) {
                           margin-top: 0;
                        }
                     }
                     &.hotel-direct-provider-info {
                        background: var(--accent-primary-lighter);
                        border: 1px solid var(--primary);
                        border-radius: 0.25rem;
                        opacity: 1;
                        text-align: center;
                        color: var(--primary);
                        font-size: var(--small);
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        line-height: 13px;
                        height: 21px;
                        box-sizing: content-box;
                        padding: 0.125rem 0.35rem;
                     }
                     &.hotel-direct-provider-recommended-info {
                        border: 1px solid var(--primary);
                        border-radius: 0.25rem;
                        opacity: 1;
                        text-align: center;
                        //color: var(--gray-50);
                        color: var(--gray-0);
                        font-size: var(--small);
                        font-weight: 700;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        line-height: 13px;
                        height: 21px;
                        box-sizing: content-box;
                        padding: 0.125rem 0.35rem;
                     }
                     &.deal-price {
                        background-color: var(--teal-0);
                        border-radius: 0.5rem;
                        color: var(--cyan-500) !important;
                        padding: 0.125rem 0.35rem;
                     }
                     &.direct {
                        margin-left: auto;
                        margin-top: 0.75rem;
                        margin-right: 2rem;

                        @media (max-width: 576px) {
                           margin: 0;
                           order: 2;
                        }
                     }
                     .hotel-card-discount {
                        text-decoration: line-through;
                        display: flex;
                        width: 147px;
                        justify-content: right;
                        &.discountedPrice {
                           color: var(--red-600);
                           font-size: 1.25rem;
                           font-weight: 500;
                        }
                        &.discountedPriceNonRec {
                           //color: var(--gray-50);
                           color: var(--gray-0);
                           font-size: 1.25rem;
                           font-weight: 400;
                        }
                     }
                     .hotel-card-discount-price {
                        display: flex;
                        width: 147px;
                        justify-content: right;
                        &.discountedPrice {
                           color: var(--teal-600);
                           font-size: 1.75rem;
                        }
                     }
                  }
               }
            }
         }
      }
   }
   .hotel-detail-collapse {
      width: 100%;
      background-color: var(--surface-level-1);
      border-radius: 0 0 12px 12px;

      .hotel-detail-inner {
         padding: 12px;

         .hotel-detail-content-tab-wrapper {
            .hotel-detail-content-tab-inner {
               .hotel-detail-content-tab-list {
                  display: flex;
                  justify-content: center;
                  border-bottom: 3px solid var(--gray-200);
                  position: relative;

                  .hotel-detail-content-tab-list-item {
                     border-left: 1px solid var(--gray-100);
                     padding: 8px 16px;
                     margin-bottom: 8px;

                     .nav-link {
                        position: relative;
                        margin: 0;
                        padding: 0;
                        border: none;
                        outline: none;
                        font-weight: 700;
                        color: var(--gray-700);

                        &:hover,
                        &:focus {
                           border: none;
                        }

                        &.active {
                           border: none;
                           color: var(--accent-primary);

                           &::after {
                              content: "";
                              position: absolute;
                              bottom: -18px;
                              left: 0;
                              display: inline-block;
                              width: 100%;
                              height: 3px;
                              background-color: var(--accent-primary);
                           }
                        }
                     }
                  }

                  .icon-close-rounded {
                     position: absolute;
                     top: 0;
                     bottom: 0;
                     margin: auto;
                     right: 1.5rem;
                  }

                  .hotel-detail-content-tab-list-item:last-child {
                     border: none !important;
                  }
                  .close-item {
                     cursor: pointer;
                  }
               }
               .hotel-detail-content-tab-content {
                  color: var(--gray-700);
                  .hotel-detail-content-tab-content-item {
                     .hotel-detail-content-tab-content-item-inner {
                        padding: 24px 20px;
                        @media (max-width: 991px) {
                           padding: 24px 0rem;
                        }
                        .hotel-content-section {
                           padding-bottom: 32px;
                           margin-bottom: 32px;
                           border-bottom: 1px solid var(--gray-100);

                           &:last-child {
                              margin-bottom: 0;
                              border-bottom: 0;
                           }

                           .hotel-content-section-title {
                              margin-bottom: 24px;
                              h4 {
                                 font-size: 14px;
                                 font-weight: 700;
                                 color: var(--gray-700);
                              }
                           }
                           .hotel-content-section-content {
                              display: flex;
                              flex-direction: column;

                              .description-content {
                                 margin: 0;
                                 font-size: var(--normal);
                                 color: var(--gray-700);

                                 &.line-clamp {
                                    display: contents;
                                    -webkit-line-clamp: 4;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                 }
                                 &.line-clamp-shrinked {
                                    display: none;
                                    &:first-child {
                                       display: contents;
                                    }
                                 }
                                 &__title {
                                    font-weight: bold;
                                    margin-top: 0.25rem;
                                    &:first-child {
                                       margin-top: 0;
                                    }
                                 }
                              }
                              .btn_readMore {
                                 text-align: right;
                                 color: var(--accent-primary);
                                 font-weight: 700;
                                 cursor: pointer;
                              }
                           }
                           &.hotel-facilities-content-section {
                              & > div {
                                 margin-bottom: 32px;
                              }
                              .hotel-content-facilities-list {
                                 display: grid;
                                 grid-template-columns: repeat(4, 1fr);

                                 @media (max-width: 576px) {
                                    grid-template-columns: repeat(3, 1fr);
                                 }

                                 .hotel-content-facilities-list-item {
                                    display: inline-flex;
                                    align-items: center;
                                    justify-content: flex-start;
                                    margin-bottom: 24px;
                                    .hotel-content-facilities-list-item-description {
                                       p {
                                          font-size: 12px;
                                          color: var(--gray-700);
                                       }
                                    }

                                    .hotel-content-facilities-list-item-icon {
                                       display: flex;
                                       justify-content: center;
                                       align-items: center;
                                       $imgSize: 42px;
                                       width: $imgSize;
                                       height: $imgSize;
                                       margin-right: 0.75rem;
                                    }
                                    img {
                                    }
                                    span {
                                       font-size: var(--small);
                                       font-weight: 500;
                                       color: var(--gray-700);
                                    }
                                 }
                              }
                              .hotel-facilities-cta-group {
                                 display: flex;
                                 justify-content: flex-end;
                                 & > span {
                                    display: flex;
                                    align-items: center;
                                    font-weight: 600;
                                    color: var(--accent-primary);
                                    cursor: pointer;

                                    & > i {
                                       margin-left: 8px;
                                       font-size: 12px;
                                    }
                                 }
                              }
                           }
                           &.hotel-map-content-section {
                              .hotel-map-wrapper {
                                 .hotel-map-inner {
                                    .static-map {
                                       position: relative;
                                       display: flex;
                                       align-items: center;
                                       justify-content: center;

                                       &::before {
                                          content: "";
                                          width: 100%;
                                          height: 100%;
                                          position: absolute;
                                          top: 0;
                                          left: 0;
                                          background-color: var(--primary-alpha-50);
                                          border-radius: 8px;
                                       }
                                       img {
                                          width: 100%;
                                          height: 300px;
                                          object-fit: cover;
                                       }
                                       & > button {
                                          position: absolute;
                                       }
                                    }
                                 }
                              }
                           }
                        }
                     }
                     &.informations-tab {
                     }
                     &.gallery-tab {
                     }
                     &.room-tab {
                        .rooms-wrapper {
                           .rooms-section {
                              .rooms-section-item {
                                 margin-bottom: 24px;
                                 border: 1px solid var(--gray-200);
                                 border-radius: 8px;

                                 &:last-child {
                                    margin-bottom: 0;
                                 }

                                 .room-section-header {
                                    display: flex;
                                    padding: 0.875rem 1.25rem;
                                    background-color: var(--gray-200);
                                    border-radius: 8px 8px 0 0;
                                    display: flex;
                                    justify-content: space-between;

                                    span {
                                       font-size: 16px;
                                       font-weight: 600;
                                       color: var(--gray-700);
                                    }

                                    .visitors-container {
                                       span {
                                          font-weight: 500 !important;
                                          color: var(--gray-500);
                                          font-size: var(--small);
                                       }
                                    }
                                 }

                                 .rooms-list {
                                    padding: 16px;
                                    @media (max-width: 991px) {
                                       padding: 0.5rem;
                                    }
                                    .load-more-room {
                                       cursor: pointer;
                                       text-align: center;
                                       padding: 0.75rem;
                                       border-radius: 0.5rem;
                                       font-weight: 500;
                                       background: var(--blue-200);
                                       color: var(--blue-700);
                                       font-size: var(--large);

                                       &:hover {
                                          background: var(--gray-800);
                                          //color: var(--gray-50);
                                          color: var(--gray-0);
                                       }
                                       span {
                                          font-size: var(--small);
                                       }
                                    }
                                    .load-more-room {
                                       cursor: pointer;
                                       text-align: center;
                                       padding: 0.75rem;
                                       border-radius: 0.5rem;
                                       font-weight: 500;
                                       background: var(--blue-100);
                                       color: var(--blue-700);
                                       font-size: var(--large);

                                       &:hover {
                                          background: var(--gray-800);
                                          //color: var(--gray-50);
                                          color: var(--gray-0);
                                       }
                                       span {
                                          font-size: var(--small);
                                       }
                                    }
                                    &.--no-matching-rooms {
                                       display: flex;
                                       justify-content: center;
                                       background-color: var(--room-bg-color);
                                       border: 1px solid var(--room-border-color);
                                       border-radius: 8px;
                                    }
                                    .rooms-list-item {
                                       margin-bottom: 24px;

                                       &:last-child {
                                          margin-bottom: 0;
                                       }
                                    }
                                 }
                              }
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }

   &.recommended-hotel {
      background-color: var(--blue-600);
      color: var(--txt-white);

      .hotel-card-content {
         border-right-color: var(--gray-200) !important;
      }
      .hotel-name > h2 {
         color: var(--txt-white) !important;
      }
      .hotel-content-info {
         .hotel-content-info-inner {
            .hotel-info-item > span {
               color: var(--txt-white);

               i {
                  width: 16px !important;
                  height: 16px !important;
                  filter: invert(255%) sepia(255%) saturate(255%) hue-rotate(255deg) brightness(255%) contrast(255%);
               }
            }
         }
      }

      .hotel-card-content-facilities {
         .facility-item {
            i {
               filter: brightness(10);
            }
            img {
               filter: brightness(10) !important;
            }
         }
      }
      .deal-price {
         background-color: transparent !important;
         color: var(--txt-white) !important;
         filter: brightness(10);
      }
      .hotel-location {
         display: flex;
         align-items: center;
         margin-top: 0.25rem;
         i {
            filter: brightness(10) !important;
         }
      }
   }
}
</style>
